import script from "./ShareCapital.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareCapital.vue?vue&type=script&setup=true&lang=js"

import "./ShareCapital.vue?vue&type=style&index=0&id=96581102&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96581102"]])

export default __exports__